import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { VersionId } from '../../../common/model/index.tsx';
import type { RelatedIssueCountResponse } from './types.tsx';

export const relatedIssueCountUrl = (id: VersionId): string =>
	`/rest/api/2/version/${id}/relatedIssueCounts`;

export const getRelatedIssueCount = (versionId: VersionId): Promise<RelatedIssueCountResponse> =>
	fetchJson(relatedIssueCountUrl(versionId));
